/** The "Need help?" callout above the chat button, shown two seconds after load. */

import { botIconImg } from "./dom";

const SHOW_AFTER_MS = 2000;

export function createCallout(container: HTMLElement, button: HTMLElement): HTMLDivElement {
  const callout = document.createElement("div");
  callout.className = "chat-widget-callout";
  callout.setAttribute("role", "tooltip");
  callout.setAttribute("aria-label", "Chatbot introduction");

  const close = document.createElement("button");
  close.type = "button";
  close.className = "chat-widget-callout-close";
  close.textContent = "×";
  close.setAttribute("aria-label", "Close introduction");
  close.addEventListener("click", () => hideCallout(callout));

  const text = document.createElement("div");
  text.className = "chat-widget-callout-text";
  const heading = document.createElement("div");
  heading.style.fontWeight = "bold";
  heading.style.marginBottom = "8px";
  heading.textContent = "Need help?";
  const description = document.createElement("div");
  description.textContent = "I'm an AI chatbot that's here to simplify shipping complexities";
  text.append(heading, description);

  const content = document.createElement("div");
  content.className = "chat-widget-callout-content";
  content.append(botIconImg("chat-widget-callout-icon"), text);
  callout.append(close, content);
  container.append(callout);

  // Point the arrow at the button's centre, clamped to the callout's edge.
  const positionArrow = () => {
    const b = button.getBoundingClientRect();
    const c = callout.getBoundingClientRect();
    const fromRight = c.right - (b.left + b.width / 2);
    callout.style.setProperty(
      "--esl-callout-arrow-right",
      `${Math.max(20, Math.min(fromRight, 100))}px`,
    );
  };

  window.setTimeout(() => {
    callout.classList.add("visible");
    window.setTimeout(positionArrow, 100);
  }, SHOW_AFTER_MS);
  window.addEventListener("resize", () => {
    if (callout.classList.contains("visible")) positionArrow();
  });
  return callout;
}

export function hideCallout(callout: HTMLElement): void {
  callout.classList.remove("visible");
  window.setTimeout(() => {
    callout.style.display = "none";
  }, 300);
}
